import React, { useEffect, useState } from "react";
import BarcodeGenerator from "../../../components/Barcode";

import moment from "moment";
import { numberWithSpacesIntl } from "../../../utils/numberWithSpaces";
import OneItem from "./component/OneItem";
import SubTitle from "./component/SubTitle";
const OrderPage = () => {
  const [data, setData] = useState(null);
  const [isShowPrice, setIsShowPrice] = useState(false);
  const [isShowWhs, setIsShowWhs] = useState(false);
  const [isShowDriver, setIsShowDriver] = useState(false);
  const [isShowLoaders, setIsShowLoaders] = useState(false);
  const [isShowManager, setIsShowManager] = useState(false);
  const [isShowSalesInfo, setIsShowSalesInfo] = useState(false);
  const [isShowSupplierInfo, setIsShowSupplierInfo] = useState(false);
  const [isShowCustomerInfo, setIsShowCustomerInfo] = useState(false);
  const [isShowInfoRequest, setIsShowInfoRequest] = useState(false);
  const [isShowWhsOnHand, setIsShowWhsOnHand] = useState(false);
  const [isPriceLower, setIsPriceLower] = useState(false);
  const [isShowPrimichaniye, setIsShowPrimichaniye] = useState(false);
  const [isShowLoaderToResponsible, setIsShowLoaderToResponsible] =
    useState(true);
  const [title, setTitle] = useState("");
  const [totalSum, setTotalSum] = useState(0);
  const [totalSumLowerPrice, setTotalSumLowerPrice] = useState(0);
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [totalQuantityPackage, setTotalQuantityPackage] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 1000);
  }, []);

  useEffect(() => {
    const storedData = sessionStorage.getItem("orderData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setData(parsedData.data);
      setIsShowPrice(parsedData.isShowPrice);
      setIsShowWhs(parsedData.isShowWhs);
      setIsShowDriver(parsedData.isShowDriver);
      setIsShowLoaders(parsedData.isShowLoaders);
      setIsShowManager(parsedData.isShowManager);
      setIsShowSalesInfo(parsedData.isShowSalesInfo);
      setIsShowSupplierInfo(parsedData.isShowSupplierInfo);
      setIsShowCustomerInfo(parsedData.isShowCustomerInfo);
      setIsShowInfoRequest(parsedData.isShowInfoRequest);
      setIsShowWhsOnHand(parsedData.isShowWhsOnHand);
      setIsShowPrimichaniye(parsedData.isShowPrimichaniye);
      setIsPriceLower(parsedData.isPriceLower);
      setIsShowLoaderToResponsible(parsedData.isShowLoaderToResponsible);
      setTitle(parsedData.title);

      setTotalSum(
        parsedData?.data?.documentLines?.reduce((acc, item) => {
          return acc + item.price * item.quantity;
        }, 0),
      );
      setTotalSumLowerPrice(
        parsedData?.data?.documentLines?.reduce((acc, item) => {
          return acc + item.price * 0.85 * item.quantity;
        }, 0),
      );
      setTotalVolume(
        parsedData?.data?.documentLines?.reduce((acc, item) => {
          return acc + +item.volume * item.quantity;
        }, 0),
      );
      setTotalWeight(
        parsedData?.data?.documentLines?.reduce((acc, item) => {
          return acc + +item.weight * item.quantity;
        }, 0),
      );
      setTotalQuantityPackage(
        parsedData?.data?.documentLines?.reduce((acc, item) => {
          let totalPackage;
          if (!item.packageQty) {
            totalPackage = 0;
          } else {
            totalPackage = item.quantity / item.packageQty;
          }
          return acc + totalPackage;
        }, 0),
      );
      console.log("ordersData", parsedData);
    }
  }, []);

  if (!data) {
    return (
      <div className="flex-items-center animate-pulse justify-center text-center text-2xl">
        Loading...
      </div>
    );
  }

  console.log(data);

  return (
    <div className="bg-white p-5 font-sans text-black">
      <div className="border-b">
        <div className="flex items-center justify-between">
          <div>
            <BarcodeGenerator
              docNum={data?.docNum}
              width={2}
              height={40}
              margin={0}
              className="ml-3 mt-0"
            />
          </div>
          <div>
            {isShowSalesInfo && (
              <div className="flex flex-col">
                <SubTitle title="Информация о заказе" className="text-sm" />
                <OneItem
                  title="Дата заказа"
                  item={moment(data?.docDate).format("DD.MM.YYYY")}
                />
                <OneItem
                  title="Дата отгрузки"
                  item={moment(data?.docDueDate).format("DD.MM.YYYY")}
                />
              </div>
            )}
            {isShowManager && <OneItem title="Менеджер" item={data?.slpName} />}
            {isShowInfoRequest && (
              <div className="mt-1 flex flex-col">
                <SubTitle title="Информация об запросе" className="text-sm" />
                <OneItem title="Дата запроса" item={data?.docDate} />

                <OneItem title="Создал " item={data?.u_CreatorWeb} />
              </div>
            )}
          </div>
        </div>

        <p className="text-center text-lg font-bold">
          {title} № {data?.docNum}
        </p>

        <div className="mb-2 flex w-full flex-col items-start">
          <div className="mt-1 flex w-full items-start justify-between text-sm">
            {isShowSupplierInfo && (
              <div className="flex w-full flex-col text-left">
                <SubTitle title="Информация о грузоотправителе" />
                <OneItem
                  title="Грузоотправитель"
                  item={"TRANSPARENT QUALITY TRADE САВДО"}
                  className={"mt-1"}
                />
                <OneItem title="Инн" item={"306014301"} />
                <OneItem
                  title="Регион"
                  item={
                    "Toshkent shahri, Uchtepa tumani, FOZIL TEPA 2-TOR KO'CHASI, 18-UY"
                  }
                />
                <OneItem title="Телефон" item={"977399932"} />
              </div>
            )}

            {isShowCustomerInfo && (
              <div className="ml-5 flex w-full flex-col text-left">
                <SubTitle title={"Информация о покупателе"} />
                <OneItem title={"Покупатель"} item={data?.cardName} />
                <OneItem title="Инн" item={data?.inn} />
                <OneItem title="Регион" item={data?.address} />
                <OneItem title="Телефон" item={data?.phoneNumber} />
              </div>
            )}
            <div></div>
          </div>
          {isShowWhs && (
            <div className="flex w-full items-start justify-between text-sm">
              <div className="flex w-full flex-col text-left">
                <OneItem title="Со склада" item={data?.fromWarehouseName} />
                <OneItem
                  title="Отвественный "
                  item={
                    isShowLoaderToResponsible
                      ? data?.shippingLoaderNames
                      : data?.fromWarehouseResponsiblePerson
                  }
                />
              </div>
              <div className="ml-5 flex w-full flex-col text-left">
                <OneItem title="На склад" item={data?.toWarehouseName} />
                <OneItem
                  title="Отвественный "
                  item={
                    isShowLoaderToResponsible
                      ? data?.receivingLoaderNames
                      : data?.toWarehouseResponsiblePerson
                  }
                />
              </div>
            </div>
          )}

          <div className="flex w-full flex-col items-start justify-between gap-2 text-sm">
            {isShowLoaders && !isShowWhs && (
              <div className="flex flex-col gap-1 text-left">
                <OneItem
                  title="Специалисты по погрузке и отгрузке"
                  item={
                    data?.loaderNames ||
                    data?.receivingLoaderNames ||
                    data?.shippingLoaderNames
                  }
                  className={"mt-1"}
                />
              </div>
            )}
            {isShowDriver && (
              <div className="flex items-start justify-between gap-10">
                <OneItem
                  title="Водитель"
                  item={data?.driverCardName || data?.u_Driver}
                />
                <OneItem title="Автотранспорт" item={data?.u_CarNumber} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mb-3 mt-1.5">
        <table className="w-full border-collapse border border-black">
          <thead>
            <tr className="print-bg-color bg-[#81857B] text-[10px] font-bold text-white print:bg-[#81857B]">
              <th className="border border-black px-0.5 py-0.5">№</th>
              <th className="border border-black px-0.5 py-0.5">Артикул</th>
              <th className="border border-black px-0.5 py-0.5">Товар</th>
              {isShowWhsOnHand && (
                <>
                  <th className="border border-black px-0.5 py-0.5">Ост.</th>
                  <th className="border border-black px-0.5 py-0.5">
                    Ост. Дос.
                  </th>
                </>
              )}
              <th className="border border-black px-0.5 py-0.5">К-во</th>
              <th className="border border-black px-0.5 py-0.5">Ед</th>

              {isShowPrice && (
                <>
                  <th className="border border-black px-0.5 py-0.5">
                    Цена товара
                  </th>
                  <th className="border border-black px-0.5 py-0.5">Сумма</th>
                </>
              )}
              <th className="border border-black px-0.5 py-0.5">Вес</th>
              <th className="border border-black px-0.5 py-0.5">Объем</th>
              <th className="border border-black px-0.5 py-0.5">
                Тип упаковки
              </th>
              <th className="border border-black px-0.5 py-0.5">
                К-во упаковок
              </th>
              <th className="border border-black px-0.5 py-0.5">Штрих код</th>
            </tr>
          </thead>
          <tbody>
            {data?.documentLines
              .sort((a, b) =>
                a.itemDescription.localeCompare(b.itemDescription, "ru"),
              )
              .map((item, idx) => {
                return (
                  <tr className="print-bg-color text-[10px] font-bold">
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {idx + 1}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {item.itemCode}
                    </td>
                    <td className="border border-black px-1 py-0.5 text-start text-[7px]">
                      {item.itemDescription}
                    </td>
                    {isShowWhsOnHand && (
                      <>
                        <td className="border border-black px-0.5 py-0.5 text-center">
                          {numberWithSpacesIntl(item?.whsOnHandQuantity)}
                        </td>
                        <td className="border border-black px-0.5 py-0.5 text-center">
                          {numberWithSpacesIntl(item?.whsAvailableQuantity)}
                        </td>
                      </>
                    )}
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {numberWithSpacesIntl(item.quantity)}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {item.measureUnit || item.unitMsr}
                    </td>
                    {isShowPrice && (
                      <>
                        <td className="border border-black px-0.5 py-0.5 text-center">
                          {isPriceLower
                            ? numberWithSpacesIntl(item.price * 0.85)
                            : numberWithSpacesIntl(item.price)}
                        </td>
                        <td className="border border-black px-0.5 py-0.5 text-center">
                          {isPriceLower
                            ? numberWithSpacesIntl(
                                item.price * 0.85 * item.quantity,
                              )
                            : numberWithSpacesIntl(item.price * item.quantity)}
                        </td>
                      </>
                    )}

                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {`${numberWithSpacesIntl(item.weight * item.quantity)}`}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {`${numberWithSpacesIntl(item.volume * item.quantity)} `}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {item.packageType}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {numberWithSpacesIntl(
                        !item.packageQty
                          ? 0
                          : (item.quantity / item.packageQty).toFixed(2),
                      )}
                    </td>
                    <td className="border border-black px-0.5 py-0.5 text-center">
                      {item.barCode && (
                        <BarcodeGenerator
                          docNum={item.barCode}
                          width={1}
                          height={20}
                          displayValue={false}
                          margin={0}
                          className="ml-3 mt-0"
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end overflow-auto">
        <table className="w-max table-auto border border-black text-sm">
          <thead>
            <tr>
              <th className="print-bg-color border border-black bg-[#81857B] px-0.5 py-0.5 text-[10px] font-bold text-white print:bg-[#81857B]">
                Общая количество:
              </th>
              {isShowPrice && (
                <th className="print-bg-color border border-black bg-[#81857B] px-0.5 py-0.5 text-[10px] font-bold text-white print:bg-[#81857B]">
                  Общая сумма:
                </th>
              )}
              <th className="print-bg-color border border-black bg-[#81857B] px-0.5 py-0.5 text-[10px] font-bold text-white print:bg-[#81857B]">
                Общая Вес:
              </th>
              <th className="print-bg-color border border-black bg-[#81857B] px-0.5 py-0.5 text-[10px] font-bold text-white print:bg-[#81857B]">
                Общая Объем:
              </th>
              <th className="print-bg-color border border-black bg-[#81857B] px-0.5 py-0.5 text-[10px] font-bold text-white print:bg-[#81857B]">
                Общая К-во Упаковок:
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-black px-0.5 py-0.5 text-center text-[10px] font-bold">
                {numberWithSpacesIntl(
                  data?.documentLines.reduce(
                    (acc, item) => acc + item.quantity,
                    0,
                  ),
                )}
              </td>
              {isShowPrice && (
                <td className="border border-black px-0.5 py-0.5 text-center text-[10px] font-bold">
                  {isPriceLower
                    ? numberWithSpacesIntl(totalSumLowerPrice)
                    : numberWithSpacesIntl(totalSum)}
                </td>
              )}
              <td className="border border-black px-0.5 py-0.5 text-center text-[10px] font-bold">
                {numberWithSpacesIntl(totalWeight)}
              </td>
              <td className="border border-black px-0.5 py-0.5 text-center text-[10px] font-bold">
                {numberWithSpacesIntl(totalVolume)}
              </td>
              <td className="border border-black px-0.5 py-0.5 text-center text-[10px] font-bold">
                {numberWithSpacesIntl(totalQuantityPackage)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-1.5 border-t pt-3">
        <div className="mt-5 grid grid-cols-3 gap-2 text-[12px]">
          <div className="text-center">
            <div className="mx-auto w-3/4 border-t border-black"></div>
            <p className="mt-2">Отпустил</p>
          </div>
          <div className="text-center">
            <div className="mx-auto w-3/4 border-t border-black"></div>
            <p className="mt-2">Получил</p>
          </div>
        </div>

        <div className="text-xl">
          <OneItem title="Комментарии" item={data?.comments} />
          {isShowPrimichaniye && (
            <>
              <OneItem
                title="ПРИМЕЧАНИЕ"
                item="Примечание: После передачи товара ответственному лицу, назначенному клиентом, и по истечении трёх календарных дней с момента передачи, компания не несёт ответственности за сохранность, комплектность и остаток товара.                                                                       "
              />
              <span className="text-[12px]">
                Эслатма: Мижоз томонидан тайинланган масъул шахсга товар
                топширилган пайтдан бошлаб уч календар куни ўтгач, компания
                товарнинг сақланиши, тўлиқлиги ва қолдиғи учун жавобгарликни ўз
                зиммасига олмайди.
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderPage;
